import { useEffect, useRef, useState } from 'react';

export default function FavoritesSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const favorites = [
    {
      id: 1,
      image:
        'https://public.readdy.ai/ai/img_res/a5aede6d579bc44ecbcb813b2423a6e7.jpg',
      name: 'Sérum Vitamina C',
      comment: 'Lo uso cada mañana.',
      link: 'https://www.amazon.es/Vitamina-Organico-Hialuronico-Hidratante-Contorno/dp/B09Y96LBXR/ref=sr_1_4_sspa?__mk_es_ES=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=6N4E9AAMZU7X&dib=eyJ2IjoiMSJ9.E8MzFN4DT8REEsEfqJPvv1EcUcNxYOEmPol-4XBEqgYA4MOcNhG224GB2OhmwDwoQkJvJrAMrb9yf3O9tNvIfu8kNkaYmIEe0D-FH7C2z-Q6cA5i96WHGIvCskJu3tRQzn1J8_8ZbPjnYi50HaaLxZFfhZ3uI7B7WFx-v26m3PnfzQnLsPgt0S_CUwT5w9bnUV93xVyVu12FpNh-Fb4i4-Cw5HsTI7lDBzXOjacC-CV1cgazJBBLUrtyFeKGJgxcGLSxnY1CNOTe9BOAK48tny7QqDH3wTvX9xXHftHc5NA.kRZCNrCFztcAe2kxK_RQCpBeaiJ7wTnjQRKxQL99ICw&dib_tag=se&keywords=serum%2Bvitamina%2Bc&qid=1771615335&rdc=1&sprefix=serum%2Bvitamina%2Bc%2Caps%2C313&sr=8-4-spons&aref=UWHinMN63R&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&th=1',
    },
    {
      id: 2,
      image:
        'https://readdy.ai/api/search-image?query=natural%20linen%20home%20textile%20folded%20on%20wooden%20surface%2C%20soft%20beige%20and%20cream%20tones%2C%20minimal%20home%20decor%20product%2C%20warm%20afternoon%20light%2C%20clean%20simple%20aesthetic%2C%20contemporary%20lifestyle%20product%20photography%2C%20cozy%20home%20atmosphere%2C%20soft%20natural%20shadows&width=400&height=500&seq=fav-product-002&orientation=portrait',
      name: 'Toallas de lino',
      comment: 'Las tengo en casa desde hace meses.',
      link: 'https://www.amazon.es/American-Soft-Linen-2020-Toallas/dp/B07ZRYZGFK/ref=sr_1_39?dib=eyJ2IjoiMSJ9.SVDG0rqNkRUWQB1e_j-8rATbDQB4HBYPtMuiJedXvlOSYhAk8saY5wiSCuUkSiulePtH7CVb5dgBqgHGy9-yiig3ixrXwF6JoIwR7XjG1VqnB0xxZ0O_F1wDmREDBdyh7GIhOtX-lf2KuycHrGo8W-7TwDcuGBlOedsSZ5ilKy5FgUGNTiZrnkViCiS4ovcHDm5BF3gnBIYAy7HRutnkQqpAQJmdM5DZ0Xo5ixG9oFTnw_IRzjkURywFsYiyufXSWKpQIVx-KS0ZCDtip0kgdlVu5sxek_FadIccj-L5nT8.8vRzNp0xHa8lwZYgA1J6YpIAgH4i3GphVPhK2P22AII&dib_tag=se&keywords=toallas%2Blino&qid=1771615162&sr=8-39&th=1',
    },
    {
      id: 3,
      image:
        'https://readdy.ai/api/search-image?query=elegant%20face%20cream%20jar%20on%20marble%20surface%20with%20natural%20light%2C%20minimal%20beauty%20product%20packaging%20in%20soft%20pink%20and%20beige%20tones%2C%20luxury%20skincare%20container%2C%20clean%20product%20photography%2C%20warm%20golden%20hour%20light%2C%20contemporary%20feminine%20aesthetic%2C%20soft%20shadows&width=400&height=500&seq=fav-product-003&orientation=portrait',
      name: 'Crema hidratante',
      comment: 'Me salvó este invierno.',
      link: 'https://www.amazon.es/DIOR-Capture-OX-C-Treatment-Creme/dp/B0F6YYG2HW/ref=sr_1_3?__mk_es_ES=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=1BWCD6Q6Z9J6A&dib=eyJ2IjoiMSJ9.LdJB63un6tJnZ_ApKGD5w19V18_u-e2L9wwnPa0hLtYJNuOy6qlQOeU_HzdgQfn3Kaalt2JRMTiZEt-hmxvuQ3QmVGbcgyIkXhLsmy6nl5qzzI6wQK2bZHnH_GNcr2PLxVNAKEwTSueRpoCxB13QonHC9bawZG9Vd-GtOMrVQemRxrN7-2Fjo666guWLy3l9RcLN81leASeoSQyl00fHWObOJgp33JYm_nHyBbQ4TlhpwyVFLTtmjhiztNTm7fPwvBiAQjVN9sntLDtkrsiH-BWDTeGNHDPnULKeMYNYhK4.le2_tf4pztiw6lLabdhUiSoVpHinuSk2gjy-vvBH1I8&dib_tag=se&keywords=crema+hidratante+facial+DIOR&qid=1771615121&sprefix=crema+hidratante+facial+dior%2Caps%2C268&sr=8-3',
    },
  ];

  return (
    <section
      ref={sectionRef}
      id="favoritos"
      className="relative bg-[#FAF9F7] py-16 lg:py-20 px-8 md:px-12 lg:px-[8%] overflow-hidden"
    >
      <div className="relative z-10">
        <div
          className={`mb-10 transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-[#222222] leading-tight tracking-[-0.01em] mb-3">
            Ahora mismo estoy usando…
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-6xl">
          {favorites.map((item, index) => (
            <a
              key={item.id}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`transition-all duration-700 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${200 + index * 150}ms` }}
            >
              <div className="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 overflow-hidden cursor-pointer">
                <div className="relative w-full h-[280px]">
                  <img
                    src={item.image}
                    alt={item.name}
                    title={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-[17px] font-semibold text-[#222222] mb-2">
                    {item.name}
                  </h3>
                  <p className="text-[15px] text-[#6B6860] font-light">{item.comment}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
